import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'トップ', href: '#hero' },
    { label: 'お悩み', href: '#concerns' },
    { label: '選ばれる理由', href: '#benefits' },
    { label: 'サービス内容', href: '#service' },
    { label: '料金', href: '#pricing' },
    { label: '対応エリア', href: '#area' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-stone-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Brand */}
          <button
            onClick={() => scrollToSection('#hero')}
            className="flex items-center hover:opacity-80 transition-opacity"
            aria-label="池田石材興業 トップへ"
          >
            <img 
              src="images/logo.png" 
              alt="池田石材興業" 
              className="h-12 w-auto md:h-14" 
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {menuItems.slice(1, -1).map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className="text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Button (Desktop) */}
          <button
            onClick={() => scrollToSection('#contact')}
            className="hidden lg:block px-6 py-2 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-full transition-all duration-300 shadow-md hover:shadow-lg"
          >
            お問い合わせ
          </button>

          {/* Hamburger Menu Button (Mobile) */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-stone-700 hover:text-amber-600 transition-colors"
            aria-label="メニュー"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden bg-white border-t border-stone-200 overflow-hidden"
          >
            <nav className="px-4 py-4 space-y-2">
              {menuItems.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollToSection(item.href)}
                  className="block w-full text-left px-4 py-3 text-stone-700 hover:bg-amber-50 hover:text-amber-700 rounded-lg transition-all duration-200 font-medium"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
